import React, { useEffect, useState } from "react";
import Select from "react-select";
import { apiService } from "../../service/ApiService";
import { Form } from "react-bootstrap";

import { useTranslation } from "react-i18next";

const VatSelect = ({ title, defaultValue = null, defaultVats = [], handler }) => {
  const {
    t,
  } = useTranslation();

  title = title === undefined ? t("forms.placeholders.selectVatRate") : title;
  const [vats, setVats] = useState(defaultVats);
  const [selectedVat, setSelectedVat] = useState(null);

  const handleChange = (e) => {
    setSelectedVat(e);
    if (e) handler(e.value);
    else handler(null);
  };

  const customStyles = {
    menu: (provided) => ({
      ...provided,
      zIndex: 9999,
    }),
  };

  const getVats = async () => {
    try {
      if (defaultVats.length !== 0) return;
      const response = await apiService.get(`api/v1/vats`);
      const availableVats = response.map((el) => {
        return {
          value: el.id,
          label: el.percent,
        };
      });
      setVats(availableVats);
    } catch (error) {
      console.error(error);
    }
  };

  const setNewValue = () => {
    const selectedVat = vats.find((el) => el.value === defaultValue);
    if (selectedVat) setSelectedVat(selectedVat);
  };

  useEffect(() => {
    getVats();
  }, []);

  useEffect(() => {
    setNewValue();
  }, [defaultValue, vats]);

  return (
    <>
      <Form.Group>
        <label>{title}</label>
        <Select
          styles={customStyles}
          isClearable={true}
          className="primary"
          name="vatSelect"
          onChange={handleChange}
          value={selectedVat}
          options={vats}
          noOptionsMessage={() => t("messages.noVatRatesAreAvailable")}
          placeholder={`${t("common.actions.select")} ${title}`}
        />
      </Form.Group>
    </>
  );
};

export default VatSelect;
